import {Extension} from "@codemirror/state";
import {CompletionEngine} from "../../../util/cafebabe/src/completion_engine";
import {
	autocompletion,
	CompletionContext,
	CompletionSource,
} from "@codemirror/autocomplete";
import CodeStore from "../../../state/codeStore";

const autocompletionExtension = (codeStore: CodeStore): Extension => {
	const completionEngine = new CompletionEngine();

	function myCompletions(context: CompletionContext) {
		const project = codeStore.cafebabeProject;
		if (!project) return null;

		const doc = context.state.doc.toString();
		const currFile = codeStore.focusedFile;
		if (!currFile || !project) return null;

		project.updateFile(currFile, doc);
		project.analyze();

		const expr = project.getFile(currFile)?.cu;
		if (!expr) return null;

		const loc = context.state.selection.main.head;
		return completionEngine.completionsAt(doc, expr, loc);
	}

	return autocompletion({
		override: [myCompletions as CompletionSource],
		activateOnTyping: true,
	});
};

export default autocompletionExtension;
